import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Addgarment from '../views/AddGarment.vue'
import Register from '../views/register.vue'
import Landing from '../views/Landing.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name:'landing',
    component: Landing
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/addgarment',
    name: 'Addgarment',
    component: Addgarment
  },
  {
    path:'/register',
    name:'Register',
    component: Register
  },
]

const router = new VueRouter({
  routes
})

export default router
